const transformWishlistModel = (wishlist) => ({
    items: wishlist.items_v2.items,
    itemsCount: wishlist.items_count,
    id: wishlist.id,
});

export { transformWishlistModel as default };
//# sourceMappingURL=transformWishlistModel.js.map
